export const Default = {
    methods: {
        initialize: function () {
        },
        hideModal: function () {
            $('.modal').modal('hide')
        },
        getLoadPossibility: function (counter, limit, loading) {
            return counter === limit && loading === false
        },
        getBlock: function (data) {
            return this.Underscore.filter(this.blocks, function(item) {
                return item.widgets.title === data
            }).slice(0,1)
        },
        getSpecificBlocks: function (data, blocks) {
            return this.Underscore.filter(blocks, function(item) {
                return item.widgets.title === data
            })
        },
        getBlocks: function (data) {
            return this.Underscore.filter(this.blocks, function(item) {
                return item.widgets.title === data
            })
        },
        getBlockTranslation: function (data, label) {
            return this.Underscore.find(data.translations[this.locality], function (item, key) {
                if (key === label) {
                    return item
                }
            })
        },
        getPages: function (type) {
            return this.pages[type]
        },
        getSequenceBlockTranslation: function (data, label) {
            return this.Underscore.find(data.page.translations[this.locality], function (item, key) {
                if (key === label) {
                    return item
                }
            })
        },
        getContent: function (data, label) {
            let content = this.Underscore.filter(data.content, function(item, key) {
                return key === label
            })
            return content.length ? content[0] : null
        },
        getUserInformation: function (data, label) {
            let result
            data.user !== null && data.user !== undefined ? result = data.user[label] : result = ''
            return result
        },
        getUserAvatar: function (data, label) {
            let result
            data.user !== null && data.user !== undefined ? result = data.user[label] : result = '/app/images/static/placeholder.jpg'
            result === null ? result = '/app/images/static/placeholder.jpg' : null
            return result
        },
        getContentPage: function (data, field, label) {
            let content = this.Underscore.filter(data, function(item, key) {
                return item.page.id === parseInt(field)
            })
            return content.length ? content : null
        },
        getSnippets: function (data) {
            let snippet = this.Underscore.filter(this.snippets, function(item) {
                return item.content.code_label === data
            })
            return snippet.length ? snippet[0].translations[this.locality].translation : data
        },
        getSettings: function (data) {
            let settings = this.Underscore.filter(this.settings, function(item) {
                return item.content.title === data
            })
            return settings.length ? settings[0].visibility : null
        },
        getHome: function (translatable, locality) {
            return translatable === true ? '/' + locality + '/' : '/'
        },
        getPath: function (data) {
            return '/' + data
        },
        getSlug: function (slug) {
            slug[slug.length -1] === '/' ? slug = slug.slice(0, -1) : null
            return slug
        },
        getPromotions: function (data, position) {
            let items
            items = data.filter(function (item) {
                return item.content.position === position
            })
            switch (items.length > 0) {
                case true:
                    return this.Lodash.head(this.Lodash.shuffle(items))
                case false:
                    return []
            }
        },
        setMessage: function (message, status) {
            this.flash(message, 'alert alert-' + status + ' notification')
        },
        setOperatingTree: function (data){
            this.$emit('setOperatingTree', data)
        },
        setOperatingItem: function (data) {
            this.item = data
        },
        setCases: function (data) {
            switch (data) {
                case true:
                    $('body').addClass('overflow-hidden')
                    $('.section-cases').addClass('shown')
                    break
                case false:
                    $('body').removeClass('overflow-hidden')
                    $('.section-cases').removeClass('shown')
                    break
            }
        },
        getOperatingTree: function(data){
            this.operatingTree = data
        },
        setCookies: function (data) {
            this.$store.dispatch('setCookies', data)
        },
        setOverflow: function () {
            $('body').removeClass('overflow-hidden')
        },
        setAuthenticationOverflow: function () {
            this.$store.state.authentication === false ? $('body').addClass('overflow-hidden') : $('body').removeClass('overflow-hidden')
        },
        setWindowTop: function () {
            $(window).scrollTop(0)
        },
        setNavigation: function (data) {
            this.$store.dispatch('setNavigation', data)
        },
        setMeta: async function () {
            let data = this.Underscore.first(this.getBlocks('Search Engine Optimisation'))
            switch (data) {
                case undefined:
                    this.meta.title = 'Verozza'
                    this.meta.author = 'Verozza'
                    this.meta.keywords = ''
                    this.meta.description = ''
                    this.meta.facebook_title = ''
                    this.meta.facebook_description = ''
                    this.meta.locality = this.locality
                    this.meta.image = 'https://via.placeholder.com/1366x768'
                    this.meta.url = window.location.href
                    break
                default:
                    this.meta.title = data.translations[this.locality].title
                    this.meta.author = data.translations[this.locality].title
                    this.meta.keywords = data.translations[this.locality].keywords
                    this.meta.description = data.translations[this.locality].description
                    this.meta.facebook_title = data.translations[this.locality].facebook_title
                    this.meta.facebook_description = data.translations[this.locality].facebook_description
                    this.meta.locality = this.locality
                    this.meta.url = window.location.href
                    let photo = this.Underscore.findWhere(this.$store.state.photos, { id: data.content.image_id })
                    switch (photo) {
                        case undefined:
                            this.meta.image = window.location.origin + '/' + 'app/images/static/placeholder.jpg'
                            break
                        default:
                            this.meta.image = window.location.origin + '/' + photo.path
                    }
            }
        },
        setLoading: function (data) {
            switch (data) {
                case true:
                    this.$store.dispatch('setLoading', data)
                    break
                case false:
                    setTimeout(() => {
                        this.$store.dispatch('setLoading', data)
                    }, 1000)
                    break
            }
        },
        setClient: async function (){
            this.$store.dispatch('setClient', await $.ajax({url: "https://geoip-db.com/jsonp", jsonpCallback: "callback", dataType: "jsonp"}))
        },
        setArticles: function (items) {
            let page = this.page
            items = items.filter(function (item) { return page.id !== item.page.id })
            items.length > 6 ? items.pop() : null
            return items
        },
        prevPaginationPage: function () {
            let wantedPage = this.sequences.current_page - 1
            if (wantedPage < 2) {
                this.$router.push({
                    path: this.$route.params.pathMatch,
                })
            } else {
                this.$router.push({
                    path: this.$route.params.pathMatch,
                    query: {
                        page: wantedPage
                    }
                })
            }
        },
        nextPaginationPage: function () {
            let wantedPage = this.sequences.current_page + 1
            this.$router.push({
                path: this.$route.params.pathMatch,
                query: {
                    page: wantedPage
                }
            })
        },
        getStripedHeadline: function (data) {
            return data.split(' ')
        }
    }
}
